module.exports = __webpack_public_path__ + "static/media/USDT(ERC20).88afa9f1.jpeg";